import combineReducers from 'combine-reducers';
import type { ActionType, StateType } from 'typesafe-actions';
import { createReducer } from 'typesafe-actions';

import type { GuardedFunction } from 'src/modules/ConfirmModal/types';
import * as actions from './actions';

const isOpened = createReducer<boolean, ActionType<typeof actions>>(false)
  .handleAction(actions.open, () => true)
  .handleAction(actions.close, () => false);

const text = createReducer<string | null, ActionType<typeof actions>>(null)
  .handleAction(actions.open, (state, action) => action.payload.text || state)
  .handleAction(actions.close, () => null);

const title = createReducer<string | null, ActionType<typeof actions>>(null)
  .handleAction(actions.open, (state, action) => action.payload.title || state)
  .handleAction(actions.close, () => null);

const confirmButton = createReducer<string | null, ActionType<typeof actions>>(null)
  .handleAction(actions.open, (state, action) => action.payload.confirmText || state)
  .handleAction(actions.close, () => null);

const cancelButton = createReducer<string | null, ActionType<typeof actions>>(null)
  .handleAction(actions.open, (state, action) => action.payload.cancelText || state)
  .handleAction(actions.close, () => null);

const guardedFunction = createReducer<GuardedFunction | null, ActionType<typeof actions>>(null)
  .handleAction(actions.open, (state, action) => action.payload.guardedFunction || state)
  .handleAction(actions.close, () => null);

const reducer = combineReducers({
  isOpened,
  guardedFunction,
  text,
  title,
  confirmButton,
  cancelButton,
});

export const initialState: StateType<typeof reducer> = {
  isOpened: false,
  guardedFunction: null,
  text: null,
  title: null,
  confirmButton: null,
  cancelButton: null,
};

export default reducer;
